import { FullAudit, IsActiveFlag } from '@/types';

export interface ConnectFlowAudioModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    name: string;
    audioFilePath: string;
}
